import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { cache } from 'tm3-core/cache';
import type FeatureEnum from 'tm3-core/enums/feature-enum';
import type IFeature from 'tm3-core/interfaces/feature';
import ConnectFeaturesStore from '../feature-store';

interface IProps extends React.PropsWithChildren {
  premium?: boolean;
  fallback?: React.ReactNode;
  valueOr?: IFeature[];
  valueAnd?: IFeature[];
  skipConfig?: boolean;
  value?: IFeature;
  flag?: FeatureEnum;
}

@observer
class ConnectFeature extends React.Component<IProps> {
  public static readonly defaultProps: Partial<IProps> = {
    premium: false
  };

  render() {
    if (!this.show) {
      return !!this.props.fallback ? <>{this.props.fallback}</> : null;
    }

    return <>{this.props.children}</>;
  }

  @computed
  get show(): boolean {
    const { flag, value, valueOr, valueAnd } = this.props;
    const { loaded } = ConnectFeaturesStore;

    if (!loaded) {
      return false;
    }
    if (!!flag) {
      return ConnectFeaturesStore.has([flag]);
    }
    if (!!value) return this.isAllowed(value);

    if (!!valueAnd) {
      for (let v of valueAnd) {
        if (!this.isAllowed(v)) return false;
      }
      return true;
    }
    if (!!valueOr) {
      for (let v of valueOr) {
        if (this.isAllowed(v)) return true;
      }
    }
    return false;
  }

  private isAllowed(value: IFeature): boolean {
    const { hasPremium, isTrial } = ConnectFeaturesStore;

    if (value.modules?.some((module) => !cache.hasAllowedModule(module))) return false;
    if (!!value.premium && !hasPremium) {
      if (!value.allowTrial || !isTrial) {
        return false;
      }
    }
    return ConnectFeaturesStore.match(value, this.props.skipConfig);
  }
}

export default ConnectFeature;
